export interface Country {
  name: string;
  phonePrefix: string;
  code: string;
}

export interface TaxType {
  value: string;
  label: string;
}

export const countries: Country[] = [
  {
    name: "Afghanistan",
    phonePrefix: "+93",
    code: "AF",
  },
  {
    name: "Aland Islands",
    phonePrefix: "+358",
    code: "AX",
  },
  {
    name: "Albania",
    phonePrefix: "+355",
    code: "AL",
  },
  {
    name: "Algeria",
    phonePrefix: "+213",
    code: "DZ",
  },
  {
    name: "AmericanSamoa",
    phonePrefix: "+1 684",
    code: "AS",
  },
  {
    name: "Andorra",
    phonePrefix: "+376",
    code: "AD",
  },
  {
    name: "Angola",
    phonePrefix: "+244",
    code: "AO",
  },
  {
    name: "Anguilla",
    phonePrefix: "+1 264",
    code: "AI",
  },
  {
    name: "Antarctica",
    phonePrefix: "+672",
    code: "AQ",
  },
  {
    name: "Antigua and Barbuda",
    phonePrefix: "+1268",
    code: "AG",
  },
  {
    name: "Argentina",
    phonePrefix: "+54",
    code: "AR",
  },
  {
    name: "Armenia",
    phonePrefix: "+374",
    code: "AM",
  },
  {
    name: "Aruba",
    phonePrefix: "+297",
    code: "AW",
  },
  {
    name: "Australia",
    phonePrefix: "+61",
    code: "AU",
  },
  {
    name: "Austria",
    phonePrefix: "+43",
    code: "AT",
  },
  {
    name: "Azerbaijan",
    phonePrefix: "+994",
    code: "AZ",
  },
  {
    name: "Bahamas",
    phonePrefix: "+1 242",
    code: "BS",
  },
  {
    name: "Bahrain",
    phonePrefix: "+973",
    code: "BH",
  },
  {
    name: "Bangladesh",
    phonePrefix: "+880",
    code: "BD",
  },
  {
    name: "Barbados",
    phonePrefix: "+1 246",
    code: "BB",
  },
  {
    name: "Belarus",
    phonePrefix: "+375",
    code: "BY",
  },
  {
    name: "Belgium",
    phonePrefix: "+32",
    code: "BE",
  },
  {
    name: "Belize",
    phonePrefix: "+501",
    code: "BZ",
  },
  {
    name: "Benin",
    phonePrefix: "+229",
    code: "BJ",
  },
  {
    name: "Bermuda",
    phonePrefix: "+1 441",
    code: "BM",
  },
  {
    name: "Bhutan",
    phonePrefix: "+975",
    code: "BT",
  },
  {
    name: "Bolivia, Plurinational State of",
    phonePrefix: "+591",
    code: "BO",
  },
  {
    name: "Bosnia and Herzegovina",
    phonePrefix: "+387",
    code: "BA",
  },
  {
    name: "Botswana",
    phonePrefix: "+267",
    code: "BW",
  },
  {
    name: "Brazil",
    phonePrefix: "+55",
    code: "BR",
  },
  {
    name: "British Indian Ocean Territory",
    phonePrefix: "+246",
    code: "IO",
  },
  {
    name: "Brunei Darussalam",
    phonePrefix: "+673",
    code: "BN",
  },
  {
    name: "Bulgaria",
    phonePrefix: "+359",
    code: "BG",
  },
  {
    name: "Burkina Faso",
    phonePrefix: "+226",
    code: "BF",
  },
  {
    name: "Burundi",
    phonePrefix: "+257",
    code: "BI",
  },
  {
    name: "Cambodia",
    phonePrefix: "+855",
    code: "KH",
  },
  {
    name: "Cameroon",
    phonePrefix: "+237",
    code: "CM",
  },
  {
    name: "Canada",
    phonePrefix: "+1",
    code: "CA",
  },
  {
    name: "Cape Verde",
    phonePrefix: "+238",
    code: "CV",
  },
  {
    name: "Cayman Islands",
    phonePrefix: "+ 345",
    code: "KY",
  },
  {
    name: "Central African Republic",
    phonePrefix: "+236",
    code: "CF",
  },
  {
    name: "Chad",
    phonePrefix: "+235",
    code: "TD",
  },
  {
    name: "Chile",
    phonePrefix: "+56",
    code: "CL",
  },
  {
    name: "China",
    phonePrefix: "+86",
    code: "CN",
  },
  {
    name: "Christmas Island",
    phonePrefix: "+61",
    code: "CX",
  },
  {
    name: "Cocos (Keeling) Islands",
    phonePrefix: "+61",
    code: "CC",
  },
  {
    name: "Colombia",
    phonePrefix: "+57",
    code: "CO",
  },
  {
    name: "Comoros",
    phonePrefix: "+269",
    code: "KM",
  },
  {
    name: "Congo",
    phonePrefix: "+242",
    code: "CG",
  },
  {
    name: "Congo, The Democratic Republic of the Congo",
    phonePrefix: "+243",
    code: "CD",
  },
  {
    name: "Cook Islands",
    phonePrefix: "+682",
    code: "CK",
  },
  {
    name: "Costa Rica",
    phonePrefix: "+506",
    code: "CR",
  },
  {
    name: "Cote d'Ivoire",
    phonePrefix: "+225",
    code: "CI",
  },
  {
    name: "Croatia",
    phonePrefix: "+385",
    code: "HR",
  },
  {
    name: "Cuba",
    phonePrefix: "+53",
    code: "CU",
  },
  {
    name: "Cyprus",
    phonePrefix: "+357",
    code: "CY",
  },
  {
    name: "Czech Republic",
    phonePrefix: "+420",
    code: "CZ",
  },
  {
    name: "Denmark",
    phonePrefix: "+45",
    code: "DK",
  },
  {
    name: "Djibouti",
    phonePrefix: "+253",
    code: "DJ",
  },
  {
    name: "Dominica",
    phonePrefix: "+1 767",
    code: "DM",
  },
  {
    name: "Dominican Republic",
    phonePrefix: "+1 849",
    code: "DO",
  },
  {
    name: "Ecuador",
    phonePrefix: "+593",
    code: "EC",
  },
  {
    name: "Egypt",
    phonePrefix: "+20",
    code: "EG",
  },
  {
    name: "El Salvador",
    phonePrefix: "+503",
    code: "SV",
  },
  {
    name: "Equatorial Guinea",
    phonePrefix: "+240",
    code: "GQ",
  },
  {
    name: "Eritrea",
    phonePrefix: "+291",
    code: "ER",
  },
  {
    name: "Estonia",
    phonePrefix: "+372",
    code: "EE",
  },
  {
    name: "Ethiopia",
    phonePrefix: "+251",
    code: "ET",
  },
  {
    name: "Falkland Islands (Malvinas)",
    phonePrefix: "+500",
    code: "FK",
  },
  {
    name: "Faroe Islands",
    phonePrefix: "+298",
    code: "FO",
  },
  {
    name: "Fiji",
    phonePrefix: "+679",
    code: "FJ",
  },
  {
    name: "Finland",
    phonePrefix: "+358",
    code: "FI",
  },
  {
    name: "France",
    phonePrefix: "+33",
    code: "FR",
  },
  {
    name: "French Guiana",
    phonePrefix: "+594",
    code: "GF",
  },
  {
    name: "French Polynesia",
    phonePrefix: "+689",
    code: "PF",
  },
  {
    name: "Gabon",
    phonePrefix: "+241",
    code: "GA",
  },
  {
    name: "Gambia",
    phonePrefix: "+220",
    code: "GM",
  },
  {
    name: "Georgia",
    phonePrefix: "+995",
    code: "GE",
  },
  {
    name: "Germany",
    phonePrefix: "+49",
    code: "DE",
  },
  {
    name: "Ghana",
    phonePrefix: "+233",
    code: "GH",
  },
  {
    name: "Gibraltar",
    phonePrefix: "+350",
    code: "GI",
  },
  {
    name: "Greece",
    phonePrefix: "+30",
    code: "GR",
  },
  {
    name: "Greenland",
    phonePrefix: "+299",
    code: "GL",
  },
  {
    name: "Grenada",
    phonePrefix: "+1 473",
    code: "GD",
  },
  {
    name: "Guadeloupe",
    phonePrefix: "+590",
    code: "GP",
  },
  {
    name: "Guam",
    phonePrefix: "+1 671",
    code: "GU",
  },
  {
    name: "Guatemala",
    phonePrefix: "+502",
    code: "GT",
  },
  {
    name: "Guernsey",
    phonePrefix: "+44",
    code: "GG",
  },
  {
    name: "Guinea",
    phonePrefix: "+224",
    code: "GN",
  },
  {
    name: "Guinea-Bissau",
    phonePrefix: "+245",
    code: "GW",
  },
  {
    name: "Guyana",
    phonePrefix: "+595",
    code: "GY",
  },
  {
    name: "Haiti",
    phonePrefix: "+509",
    code: "HT",
  },
  {
    name: "Holy See (Vatican City State)",
    phonePrefix: "+379",
    code: "VA",
  },
  {
    name: "Honduras",
    phonePrefix: "+504",
    code: "HN",
  },
  {
    name: "Hong Kong",
    phonePrefix: "+852",
    code: "HK",
  },
  {
    name: "Hungary",
    phonePrefix: "+36",
    code: "HU",
  },
  {
    name: "Iceland",
    phonePrefix: "+354",
    code: "IS",
  },
  {
    name: "India",
    phonePrefix: "+91",
    code: "IN",
  },
  {
    name: "Indonesia",
    phonePrefix: "+62",
    code: "ID",
  },
  {
    name: "Iran, Islamic Republic of Persian Gulf",
    phonePrefix: "+98",
    code: "IR",
  },
  {
    name: "Iraq",
    phonePrefix: "+964",
    code: "IQ",
  },
  {
    name: "Ireland",
    phonePrefix: "+353",
    code: "IE",
  },
  {
    name: "Isle of Man",
    phonePrefix: "+44",
    code: "IM",
  },
  {
    name: "Israel",
    phonePrefix: "+972",
    code: "IL",
  },
  {
    name: "Italy",
    phonePrefix: "+39",
    code: "IT",
  },
  {
    name: "Jamaica",
    phonePrefix: "+1 876",
    code: "JM",
  },
  {
    name: "Japan",
    phonePrefix: "+81",
    code: "JP",
  },
  {
    name: "Jersey",
    phonePrefix: "+44",
    code: "JE",
  },
  {
    name: "Jordan",
    phonePrefix: "+962",
    code: "JO",
  },
  {
    name: "Kazakhstan",
    phonePrefix: "+7 7",
    code: "KZ",
  },
  {
    name: "Kenya",
    phonePrefix: "+254",
    code: "KE",
  },
  {
    name: "Kiribati",
    phonePrefix: "+686",
    code: "KI",
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    phonePrefix: "+850",
    code: "KP",
  },
  {
    name: "Korea, Republic of South Korea",
    phonePrefix: "+82",
    code: "KR",
  },
  {
    name: "Kosovo",
    phonePrefix: "+383",
    code: "XK",
  },
  {
    name: "Kuwait",
    phonePrefix: "+965",
    code: "KW",
  },
  {
    name: "Kyrgyzstan",
    phonePrefix: "+996",
    code: "KG",
  },
  {
    name: "Laos",
    phonePrefix: "+856",
    code: "LA",
  },
  {
    name: "Latvia",
    phonePrefix: "+371",
    code: "LV",
  },
  {
    name: "Lebanon",
    phonePrefix: "+961",
    code: "LB",
  },
  {
    name: "Lesotho",
    phonePrefix: "+266",
    code: "LS",
  },
  {
    name: "Liberia",
    phonePrefix: "+231",
    code: "LR",
  },
  {
    name: "Libyan Arab Jamahiriya",
    phonePrefix: "+218",
    code: "LY",
  },
  {
    name: "Liechtenstein",
    phonePrefix: "+423",
    code: "LI",
  },
  {
    name: "Lithuania",
    phonePrefix: "+370",
    code: "LT",
  },
  {
    name: "Luxembourg",
    phonePrefix: "+352",
    code: "LU",
  },
  {
    name: "Macao",
    phonePrefix: "+853",
    code: "MO",
  },
  {
    name: "Macedonia",
    phonePrefix: "+389",
    code: "MK",
  },
  {
    name: "Madagascar",
    phonePrefix: "+261",
    code: "MG",
  },
  {
    name: "Malawi",
    phonePrefix: "+265",
    code: "MW",
  },
  {
    name: "Malaysia",
    phonePrefix: "+60",
    code: "MY",
  },
  {
    name: "Maldives",
    phonePrefix: "+960",
    code: "MV",
  },
  {
    name: "Mali",
    phonePrefix: "+223",
    code: "ML",
  },
  {
    name: "Malta",
    phonePrefix: "+356",
    code: "MT",
  },
  {
    name: "Marshall Islands",
    phonePrefix: "+692",
    code: "MH",
  },
  {
    name: "Martinique",
    phonePrefix: "+596",
    code: "MQ",
  },
  {
    name: "Mauritania",
    phonePrefix: "+222",
    code: "MR",
  },
  {
    name: "Mauritius",
    phonePrefix: "+230",
    code: "MU",
  },
  {
    name: "Mayotte",
    phonePrefix: "+262",
    code: "YT",
  },
  {
    name: "Mexico",
    phonePrefix: "+52",
    code: "MX",
  },
  {
    name: "Micronesia, Federated States of Micronesia",
    phonePrefix: "+691",
    code: "FM",
  },
  {
    name: "Moldova",
    phonePrefix: "+373",
    code: "MD",
  },
  {
    name: "Monaco",
    phonePrefix: "+377",
    code: "MC",
  },
  {
    name: "Mongolia",
    phonePrefix: "+976",
    code: "MN",
  },
  {
    name: "Montenegro",
    phonePrefix: "+382",
    code: "ME",
  },
  {
    name: "Montserrat",
    phonePrefix: "+1664",
    code: "MS",
  },
  {
    name: "Morocco",
    phonePrefix: "+212",
    code: "MA",
  },
  {
    name: "Mozambique",
    phonePrefix: "+258",
    code: "MZ",
  },
  {
    name: "Myanmar",
    phonePrefix: "+95",
    code: "MM",
  },
  {
    name: "Namibia",
    phonePrefix: "+264",
    code: "NA",
  },
  {
    name: "Nauru",
    phonePrefix: "+674",
    code: "NR",
  },
  {
    name: "Nepal",
    phonePrefix: "+977",
    code: "NP",
  },
  {
    name: "Netherlands",
    phonePrefix: "+31",
    code: "NL",
  },
  {
    name: "New Caledonia",
    phonePrefix: "+687",
    code: "NC",
  },
  {
    name: "New Zealand",
    phonePrefix: "+64",
    code: "NZ",
  },
  {
    name: "Nicaragua",
    phonePrefix: "+505",
    code: "NI",
  },
  {
    name: "Niger",
    phonePrefix: "+227",
    code: "NE",
  },
  {
    name: "Nigeria",
    phonePrefix: "+234",
    code: "NG",
  },
  {
    name: "Niue",
    phonePrefix: "+683",
    code: "NU",
  },
  {
    name: "Norfolk Island",
    phonePrefix: "+672",
    code: "NF",
  },
  {
    name: "Northern Mariana Islands",
    phonePrefix: "+1 670",
    code: "MP",
  },
  {
    name: "Norway",
    phonePrefix: "+47",
    code: "NO",
  },
  {
    name: "Oman",
    phonePrefix: "+968",
    code: "OM",
  },
  {
    name: "Pakistan",
    phonePrefix: "+92",
    code: "PK",
  },
  {
    name: "Palau",
    phonePrefix: "+680",
    code: "PW",
  },
  {
    name: "Panama",
    phonePrefix: "+507",
    code: "PA",
  },
  {
    name: "Palestine",
    phonePrefix: "+970",
    code: "PS",
  },
  {
    name: "Papua New Guinea",
    phonePrefix: "+675",
    code: "PG",
  },
  {
    name: "Paraguay",
    phonePrefix: "+595",
    code: "PY",
  },
  {
    name: "Peru",
    phonePrefix: "+51",
    code: "PE",
  },
  {
    name: "Philippines",
    phonePrefix: "+63",
    code: "PH",
  },
  {
    name: "Pitcairn",
    phonePrefix: "+872",
    code: "PN",
  },
  {
    name: "Poland",
    phonePrefix: "+48",
    code: "PL",
  },
  {
    name: "Portugal",
    phonePrefix: "+351",
    code: "PT",
  },
  {
    name: "Puerto Rico",
    phonePrefix: "+1 939",
    code: "PR",
  },
  {
    name: "Qatar",
    phonePrefix: "+974",
    code: "QA",
  },
  {
    name: "Romania",
    phonePrefix: "+40",
    code: "RO",
  },
  {
    name: "Russia",
    phonePrefix: "+7",
    code: "RU",
  },
  {
    name: "Rwanda",
    phonePrefix: "+250",
    code: "RW",
  },
  {
    name: "Reunion",
    phonePrefix: "+262",
    code: "RE",
  },
  {
    name: "Saint Barthelemy",
    phonePrefix: "+590",
    code: "BL",
  },
  {
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    phonePrefix: "+290",
    code: "SH",
  },
  {
    name: "Saint Kitts and Nevis",
    phonePrefix: "+1 869",
    code: "KN",
  },
  {
    name: "Saint Lucia",
    phonePrefix: "+1 758",
    code: "LC",
  },
  {
    name: "Saint Martin",
    phonePrefix: "+590",
    code: "MF",
  },
  {
    name: "Saint Pierre and Miquelon",
    phonePrefix: "+508",
    code: "PM",
  },
  {
    name: "Saint Vincent and the Grenadines",
    phonePrefix: "+1 784",
    code: "VC",
  },
  {
    name: "Samoa",
    phonePrefix: "+685",
    code: "WS",
  },
  {
    name: "San Marino",
    phonePrefix: "+378",
    code: "SM",
  },
  {
    name: "Sao Tome and Principe",
    phonePrefix: "+239",
    code: "ST",
  },
  {
    name: "Saudi Arabia",
    phonePrefix: "+966",
    code: "SA",
  },
  {
    name: "Senegal",
    phonePrefix: "+221",
    code: "SN",
  },
  {
    name: "Serbia",
    phonePrefix: "+381",
    code: "RS",
  },
  {
    name: "Seychelles",
    phonePrefix: "+248",
    code: "SC",
  },
  {
    name: "Sierra Leone",
    phonePrefix: "+232",
    code: "SL",
  },
  {
    name: "Singapore",
    phonePrefix: "+65",
    code: "SG",
  },
  {
    name: "Slovakia",
    phonePrefix: "+421",
    code: "SK",
  },
  {
    name: "Slovenia",
    phonePrefix: "+386",
    code: "SI",
  },
  {
    name: "Solomon Islands",
    phonePrefix: "+677",
    code: "SB",
  },
  {
    name: "Somalia",
    phonePrefix: "+252",
    code: "SO",
  },
  {
    name: "South Africa",
    phonePrefix: "+27",
    code: "ZA",
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    phonePrefix: "+500",
    code: "GS",
  },
  {
    name: "Spain",
    phonePrefix: "+34",
    code: "ES",
  },
  {
    name: "Sri Lanka",
    phonePrefix: "+94",
    code: "LK",
  },
  {
    name: "Sudan",
    phonePrefix: "+249",
    code: "SD",
  },
  {
    name: "Suriname",
    phonePrefix: "+597",
    code: "SR",
  },
  {
    name: "Svalbard and Jan Mayen",
    phonePrefix: "+47",
    code: "SJ",
  },
  {
    name: "Swaziland",
    phonePrefix: "+268",
    code: "SZ",
  },
  {
    name: "Sweden",
    phonePrefix: "+46",
    code: "SE",
  },
  {
    name: "Switzerland",
    phonePrefix: "+41",
    code: "CH",
  },
  {
    name: "Syrian Arab Republic",
    phonePrefix: "+963",
    code: "SY",
  },
  {
    name: "Taiwan",
    phonePrefix: "+886",
    code: "TW",
  },
  {
    name: "Tajikistan",
    phonePrefix: "+992",
    code: "TJ",
  },
  {
    name: "Tanzania, United Republic of Tanzania",
    phonePrefix: "+255",
    code: "TZ",
  },
  {
    name: "Thailand",
    phonePrefix: "+66",
    code: "TH",
  },
  {
    name: "Timor-Leste",
    phonePrefix: "+670",
    code: "TL",
  },
  {
    name: "Togo",
    phonePrefix: "+228",
    code: "TG",
  },
  {
    name: "Tokelau",
    phonePrefix: "+690",
    code: "TK",
  },
  {
    name: "Tonga",
    phonePrefix: "+676",
    code: "TO",
  },
  {
    name: "Trinidad and Tobago",
    phonePrefix: "+1 868",
    code: "TT",
  },
  {
    name: "Tunisia",
    phonePrefix: "+216",
    code: "TN",
  },
  {
    name: "Turkey",
    phonePrefix: "+90",
    code: "TR",
  },
  {
    name: "Turkmenistan",
    phonePrefix: "+993",
    code: "TM",
  },
  {
    name: "Turks and Caicos Islands",
    phonePrefix: "+1 649",
    code: "TC",
  },
  {
    name: "Tuvalu",
    phonePrefix: "+688",
    code: "TV",
  },
  {
    name: "Uganda",
    phonePrefix: "+256",
    code: "UG",
  },
  {
    name: "Ukraine",
    phonePrefix: "+380",
    code: "UA",
  },
  {
    name: "United Arab Emirates",
    phonePrefix: "+971",
    code: "AE",
  },
  {
    name: "United Kingdom",
    phonePrefix: "+44",
    code: "GB",
  },
  {
    name: "United States",
    phonePrefix: "+1",
    code: "US",
  },
  {
    name: "Uruguay",
    phonePrefix: "+598",
    code: "UY",
  },
  {
    name: "Uzbekistan",
    phonePrefix: "+998",
    code: "UZ",
  },
  {
    name: "Vanuatu",
    phonePrefix: "+678",
    code: "VU",
  },
  {
    name: "Venezuela, Bolivarian Republic of Venezuela",
    phonePrefix: "+58",
    code: "VE",
  },
  {
    name: "Vietnam",
    phonePrefix: "+84",
    code: "VN",
  },
  {
    name: "Virgin Islands, British",
    phonePrefix: "+1 284",
    code: "VG",
  },
  {
    name: "Virgin Islands, U.S.",
    phonePrefix: "+1 340",
    code: "VI",
  },
  {
    name: "Wallis and Futuna",
    phonePrefix: "+681",
    code: "WF",
  },
  {
    name: "Yemen",
    phonePrefix: "+967",
    code: "YE",
  },
  {
    name: "Zambia",
    phonePrefix: "+260",
    code: "ZM",
  },
  {
    name: "Zimbabwe",
    phonePrefix: "+263",
    code: "ZW",
  },
];

export function getCountryCodeByName(name?: string): string | undefined {
  return countries.find((country) => country.name === name)?.code;
}

export function getTaxTypes(countryCode: string): TaxType[] {
  if ("CA" === countryCode) {
    return [
      { value: "CA_QST", label: "CA QST" },
      { value: "CA_BN", label: "CA BN" },
    ];
  }
  return [];
}
